export function truncateString(str, n) {
  if (!str || str.length <= n) {
    return str;
  }
  const subString = str.slice(0, n - 1); // the original check
  return subString.slice(0, subString.lastIndexOf(' ')) + '...';
}
